import Api from "../config/Axios";

export const getOrderDispactherNoteList = (token, user_id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.get(`/api/web/order/dispatch-notes`, config);
};

export const getOrderDispactherNoteSingle = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.get(`/api/web/order/dispatch-notes/${id}`, config);
};

export const deleteOrderDispactherNote = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.delete(`/api/web/order/dispatch-notes/${id}`, config);
};

export const postOrderDispactherNote = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.post(`/api/web/order/dispatch-notes`, data, config);
};

export const patchOrderDispactherNote = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.patch(`/api/web/order/dispatch-notes-update/${id}`, data, config);
};